import { createContext, PropsWithChildren, useContext } from "react";

import { usePermissions } from "#modules/permissions/view/usePermissions";

export type PermissionsContextType = {
  webInterfaceV2: boolean;
  searchSimilarPart: boolean;
  predict: boolean;
  twoD: boolean;
};

const PermissionsContext = createContext<PermissionsContextType>({
  webInterfaceV2: false,
  searchSimilarPart: false,
  predict: false,
  twoD: false,
});

export const PermissionsProvider = ({ children }: PropsWithChildren) => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) {
    return null;
  }

  const getPermission = (name: string) =>
    permissions.find((p) => p.name === name)?.enabled ?? false;

  return (
    <PermissionsContext.Provider
      value={{
        webInterfaceV2: getPermission("WEB_INTERFACE_V2"),
        searchSimilarPart: getPermission("SEARCH_SIMILAR_PART"),
        predict: getPermission("PREDICT"),
        twoD: getPermission("2D"),
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissionsContext = () => useContext(PermissionsContext);
